<div class="calendarContainer">
    <div class="monthName">{{monthName}} <ng-container *ngIf="getIsTimesheetView()">{{calendarData.year}}</ng-container></div>
    <div class="calendar">
        
        <div class="weeks" *ngIf="getIsYearView()">
            <span>Sa</span>
            <span>Su</span>
            <span>Mo</span>
            <span>Tu</span>
            <span>We</span>
            <span>Th</span>
            <span>Fr</span>
        </div>

        <div class="weeks" *ngIf="getIsTimesheetView()">
            <span>Sat</span>
            <span>Sun</span>
            <span>Mon</span>
            <span>Tue</span>
            <span>Wed</span>
            <span>Thu</span>
            <span>Fri</span>
        </div>

        <div class="days">
            <ng-container *ngFor="let timesheet of calendarData.timesheets; let timesheetIndex = index">
                <div class="week">
                    <ng-container *ngFor="let loop of [].constructor(7); let currentDay = index;">
                        <div class="day" [class.dayBorder]="getShouldShowDay(timesheet, currentDay)" [class.selectedTimesheet]="getIsSelectedTimesheet(timesheet)"
                            [class.isStat]="getIsStatHoliday(timesheet, currentDay)" [class.shouldShadeEntry]="getShouldShadeTimesheetEntries(timesheet, currentDay)"
                            [class.timesheetView]="getIsTimesheetView()" [class.workWeekDay]="getShouldEnableDayHover(timesheet, currentDay)" 
                            (click)="handleTimesheetClick(timesheet)">
                            
                            <div class="triangle triangle_tl" *ngIf="getIsPayDay(timesheet, currentDay)"></div>
                            <div class="triangle triangle_tr" *ngIf="getIsHolidayClosure(timesheet, currentDay)"></div>
    
                            <div *ngIf="getIsCDODay(timesheet, currentDay)" class="CDO"></div>
                            <div *ngIf="shouldHighlightCurrentDay(timesheet, currentDay)" class="currentDayHighlight"></div>
    
                            <span class="dayEntry" [class.CDO]="getIsCDODay(timesheet, currentDay)" [class.inActiveDate]="getIsNeighborMonth(timesheet, currentDay)" 
                                [class.currentDayHighlight]="shouldHighlightCurrentDay(timesheet, currentDay)">
    
                                {{ getCurrentDate(timesheet, currentDay) }}
                            </span>
    
                            <div class="timesheetBarContainer">
                                <ng-container *ngIf="getShouldShowAdvancedTooltip(timesheet, currentDay)">
                                    <div class="calendarBar" [class.roundedBoarder]="getIsTimesheetView()" [style]="getCalendarBarStyles(timesheet, currentDay)"></div>
                                    <div *ngIf="getIsSavedOrPredictedData(timesheet)" class="calendarBar unsubmittedMask" [class.roundedBorder]="getIsTimesheetView()"></div>
                                </ng-container>
                                
                                <ng-container *ngIf="getShouldShowBasicTooltip(timesheet, currentDay) || getShouldShowAdvancedTooltip(timesheet, currentDay)">
                                    <div class="arrow-up" *ngIf="getIsYearView()"></div>
                                    <div class="timesheetHoverPanel" *ngIf="getIsYearView()">
        
                                        <ng-container *ngIf="isFilterEntry(timesheet, currentDay)">
                                            <div class="entryRow" *ngIf="getIsPayDay(timesheet, currentDay)">
                                                <div class="tooltipPayDay">
                                                    <div class="triangle triangle_tl_small"></div>
                                                </div>
                                                <span class="tooltipFilterText">Pay Day</span>
                                            </div>
                
                                            <div class="entryRow" *ngIf="getIsHolidayClosure(timesheet, currentDay)">
                                                <div class="tooltipHolidayClosure">
                                                    <div class="triangle triangle_tr_small"></div>
                                                </div>
                                                <span class="tooltipFilterText">Holiday Closure</span>
                                            </div>
                
                                            <div class="entryRow" *ngIf="getIsStatHoliday(timesheet, currentDay)">
                                                <div class="tooltipStat stat"></div>
                                                <span class="tooltipFilterText">{{getStatHolidayName(timesheet, currentDay)}}</span>
                                            </div>
                                            
                                            <div class="entryRow" *ngIf="getIsCDODay(timesheet, currentDay)">
                                                <div class="tooltipCDO">
                                                    <div class="cdo_small"></div>
                                                </div>
                                                <span class="tooltipFilterText">Compressed Day Off</span>
                                            </div>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="getShouldShowAdvancedTooltip(timesheet, currentDay)">
                                            <hr *ngIf="getShouldShowBasicTooltip(timesheet, currentDay)">
                                        
                                            <ng-container *ngFor="let entry of timesheet.entries">
                                                <div class="entryRow" *ngIf="getHasEntryWithDuration(entry, currentDay)">
                                                    <div class="timeEntryColor" [style]="getTimesheetEntryColorStyling(entry)"></div>
                                                    <div class="timeEntryEntryType">{{entry.name}}</div>
                                                    <div class="timeEntryEntryTime">{{getTimeEntryEntryTimeAmount(entry, currentDay)}}</div>
                                                </div>
                                            </ng-container>
                    
                                            <div class="entryRow">
                                                <div class="timeEntryTotalText">TOTAL</div>
                                                <div class="timeEntryTotalTime">{{getTotalCalculatedTime(timesheet, currentDay)}}</div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>